import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export const getVariablesConfigurationSensor = async () => {
    try {
        const response = await axios.get(`${apiUrl}/variables/configuration-sensor`, { ///all
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error loading variables: ', error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};